import { styled } from '@frontend/theme';
import { Chip as MuiChip } from '@mui/material';
import { ChipProps } from './Chip.types';

export const ChipSt = styled(MuiChip, {
  shouldForwardProp: prop =>
    prop !== 'colorText' && prop !== 'colorIcon' && prop !== 'colorBackground',
})<ChipProps>(({ theme, colorText, colorIcon, colorBackground }) => ({
  borderRadius: '0px',
  color: colorText || theme?.palette.neutral[700],
  backgroundColor: colorBackground || theme?.palette.neutral[50],
  '&.MuiChip-sizeMedium': {
    height: '30px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    gap: '4px',
    padding: '0px 8px',
  },
  '> .MuiChip-label': {
    paddingLeft: '6px',
    paddingRight: '0px',
  },
  '> .MuiChip-icon': {
    color: colorIcon || colorText || theme?.palette.neutral[500],
    marginLeft: '0px',
  },
}));
